import clsx from "clsx";
import {
  InputAdornment,
  makeStyles,
  TextField,
  Theme,
} from "@material-ui/core";
import * as React from "react";
import { Search } from "@material-ui/icons";

const useStyle = makeStyles((theme: Theme) => ({
  searchField: {
    width: 180,
    horizontalAlign: "middle",
    alignItems: "flex-end",
    fontFamily: "Roboto, Helvetica, Arial, serif",
    fontSize: "16px",

    "& .MuiInputBase-input::placeholder": {
      color: "#818181",
    },
  },
  icon: {
    display: "flex",
    verticalAlign: "middle",
  },
}));

interface SearchBoxProps {
  searchQuery: string;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  placeholder?: string;
  disabled?: boolean;
}

export default function SearchBox({
  searchQuery,
  onChange,
  placeholder = "Search",
  disabled,
}: SearchBoxProps) {
  const classes = useStyle();

  return (
    <TextField
      size="small"
      fullWidth
      variant="outlined"
      autoComplete="off"
      onChange={onChange}
      disabled={disabled}
      value={searchQuery}
      className={clsx(classes.searchField)}
      name="search"
      InputProps={{
        placeholder: placeholder,
        startAdornment: (
          <InputAdornment position="start">
            <Search className={clsx(classes.icon)} />
          </InputAdornment>
        ),
      }}
    />
  );
}
